import { IncomingHttpHeaders } from 'http';
import { apiClient } from '@doda/api-client/util/apiClient';
import { SavedSearchRequest } from '@doda/api-client/aspida/@types';

// TODO:取得処理以外もあるためファイル名を適切なものに変更する

/**
 * 検索条件取得(全件取得)
 * @param {IncomingHttpHeaders} headers
 * @return {SavedSearchResponse[]} 保存した検索条件一覧
 */
export const getSavedSearches = async (headers?: IncomingHttpHeaders) => {
  const res = await apiClient.api.v1.savedSearches.$get({
    config: { headers },
  });
  return res;
};

/**
 * 検索条件取得
 * @param {string} no 検索条件No
 * @param {IncomingHttpHeaders} headers
 * @return {SavedSearchResponse} 保存した検索条件一覧
 */
export const getSavedSearch = async (
  no: string,
  headers?: IncomingHttpHeaders
) => {
  const res = await apiClient.api.v1.savedSearches._no(no).$get({
    config: { headers },
  });
  return res;
};

/**
 * 検索条件保存
 * @param {number} savedCount 保存されている検索条件数
 * @param {SavedSearchRequest} params
 * @param {IncomingHttpHeaders} headers
 */
export const postSavedSearches = async (
  data: SavedSearchRequest,
  headers?: IncomingHttpHeaders
) => {
  await apiClient.api.v1.savedSearches.$post({
    body: data,
    config: { headers },
  });
};

/**
 * 検索条件更新
 * @param {string} no 検索条件No
 * @param {SavedSearchesBody} params
 * @param {IncomingHttpHeaders} headers
 */
export const putSavedSearches = async (
  no: string,
  data: SavedSearchRequest,
  headers?: IncomingHttpHeaders
) => {
  await apiClient.api.v1.savedSearches
    ._no(no)
    .$put({ body: data, config: { headers } });
};
